import React from 'react'
import './App.scss'
import { Helmet } from 'react-helmet'
import Home from './views/Home'
// import { createBrowserRouter, Navigate, redirect, RouterProvider } from 'react-router-dom'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import ChatbotHome from './views/Chatbot'
import ChatbotCommands from './views/Chatbot/Commands'
import ChatbotFeatures from './views/Chatbot/Features'
import ChatbotFAQs from './views/Chatbot/FAQs'
import ChatbotDownload from './views/Chatbot/Download'
// import API from './api'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
    errorElement: <Navigate to='/' />,
  },
  {
    path: '/chatbot',
    element: <ChatbotHome />,
    errorElement: <Navigate to='/chatbot' />,
  },
  {
    path: '/chatbot/*',
    element: <Navigate to='/chatbot' />,
  },
  {
    path: '/chatbot/features',
    element: <ChatbotFeatures />,
  },
  {
    path: '/chatbot/faqs',
    element: <ChatbotFAQs />,
  },
  {
    path: '/chatbot/commands/:username',
    element: <ChatbotCommands />,
  },
  {
    path: '/chatbot/download',
    element: <ChatbotDownload />,
  },
  // {
  //   path: '/chatbot/download',
  //   loader: async () => {
  //     try {
  //       const { link } = await API.getDownloadInfo()
  //       return redirect(link)
  //     } catch {
  //       return redirect('/chatbot') // or wherever you want
  //     }
  //   },
  //   element: <ChatbotDownload />,
  // },
])

function App() {
  return (
    <div className='App'>
      <Helmet>
        <meta charSet='utf-8' />
        <title>Draconem Labs</title>
      </Helmet>
      <RouterProvider router={router} />
    </div>
  )
}

export default App
